import React from 'react';

import { Show } from 'shared';
import { Nullable } from 'shared_DEPRECATED/types';
import { LinkPreview } from 'types/common';

import { ChatMessageLinkPreviewUnuploaded } from 'features/chat/components/ChatMessages/ChatMessageLinkPreviewUnuploaded';
import { ChatMessageLinkPreviewUploaded } from 'features/chat/components/ChatMessages/LinkPreviewUploaded';

export const ChatMessageLinkPreview = ({
  linkPreview,
  text,
}: {
  linkPreview?: Nullable<LinkPreview>;
  text?: string;
}) => (
  <Show
    when={linkPreview}
    fallback={<ChatMessageLinkPreviewUnuploaded text={text || ''} />}
  >
    {(linkPreview) => {
      const { title, description, imageMetadata, url } = linkPreview;

      return (
        <ChatMessageLinkPreviewUploaded
          title={title}
          description={description}
          image={imageMetadata?.url}
          url={url}
        />
      );
    }}
  </Show>
);
